/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Muhammad Atique",
  description:
    "A seasoned Senior PHP Developer with extensive experience in PHP, MySQL, Laravel, Symfony, WordPress, and CodeIgniter. Proficient in front-end technologies including jQuery, Bootstrap, HTML, CSS3, and JavaScript, and skilled in converting Figma/PSD designs into responsive websites. Overall, I completed 300 plus successful projects with more than 200 completed jobs on Upwork with 5-star feedback.",
  og: {
    title: "Muhammad Atique Portfolio",
    type: "website",
    url: "http://atique.eu/",
  },
};

//Home Page
const greeting = {
  title: "Muhammad Atique",
  logo_name: "Muhammad Atique",
  nickname: "",
  subTitle:
    "A seasoned Senior PHP Developer with extensive experience in PHP, MySQL, Laravel, Symfony, WordPress, and CodeIgniter.",
  resumeLink:
    "http://atique.eu/Muhammad-Atique.pdf",
  portfolio_repository: "https://github.com/matiq83",
  githubProfile: "https://github.com/matiq83",
};

const socialMediaLinks = [
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/muhammad-atiq-5b352ab/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "Github",
    link: "https://github.com/matiq83",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "Gmail",
    link: "mailto:atiq132001@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "WhatsApp",
    link: "https://api.whatsapp.com/send?phone=923337668238",
    fontAwesomeIcon: "fa-whatsapp", // Reference https://fontawesome.com/icons/facebook-f?style=brands
    backgroundColor: "#52CD5E", // Reference https://simpleicons.org/?q=facebook
  },
  {
    name: "X-Twitter",
    link: "https://x.com/atiq3337668238",
    fontAwesomeIcon: "fa-x-twitter", // Reference https://fontawesome.com/icons/x-twitter?f=brands&s=solid
    backgroundColor: "#000000", // Reference https://simpleicons.org/?q=x
  },
  {
    name: "Instagram",
    link: "https://www.instagram.com/muhammad.atiq.509/",
    fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  },
];

const skills = {
  data: [
    {
      title: "PHP Backend Development",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Proficiency in popular frameworks like Laravel, Symfony, CodeIgniter, CakePHP",
        "⚡ Proficiency in core PHP and OOP (Object-Oriented Programming)",
        "⚡ Expertise in WordPress plugins/themes coding from scratch",
        "⚡ Knowledge of PSR standards, Composer, and dependency injection",
        "⚡ Expertise in MySQL, PostgreSQL, MongoDB, or MariaDB databases",
      ],
      softwareSkills: [
        {
          skillName: "PHP",
          imageSrc: "devicon--php.png",
        },
        {
          skillName: "Laravel",
          imageSrc: "logos--laravel.png",
        },
        {
          skillName: "Symfony",
          imageSrc: "devicon--symfony.png",
        },
        {
          skillName: "CodeIgniter",
          imageSrc: "logos--codeigniter-icon.png",
        },
        {
          skillName: "CakePHP",
          imageSrc: "devicon--cakephp.png",
        },
        {
          skillName: "WordPress",
          imageSrc: "devicon-plain--wordpress.png",
        },
        {
          skillName: "WordPress Plugin",
          imageSrc: "bi--plugin.png",
        },
        {
          skillName: "WooCommerce",
          imageSrc: "devicon--woocommerce.png",
        },
        {
          skillName: "MySQL",
          imageSrc: "logos--mysql.png",
        },
        {
          skillName: "MongoDB",
          imageSrc: "devicon--mongodb.png",
        },
        {
          skillName: "PostgreSQL",
          imageSrc: "logos--postgresql.png",
        }
      ],
    },
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Experience developing and integrating RESTful APIs, working with AJAX and JSON",
        "⚡ Deep understanding of HTML5, CSS3, and JavaScript (ES6+)",
        "⚡ Ability to build responsive UI using Bootstrap, Tailwind CSS, or custom styles",
        "⚡ Experience with vanilla JS, jQuery and Vue.js",
        "⚡ Developing mobile applications using Apache Cordova",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "API",
          imageSrc: "gravity-ui--abbr-api.png",
        },
        {
          skillName: "GraphQL",
          imageSrc: "logos--graphql.png",
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "jQuery",
          imageSrc: "devicon--jquery-wordmark.png",
        },
        {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837",
          },
        },
        {
          skillName: "JSON",
          imageSrc: "catppuccin--json-schema.png",
        },
        {
          skillName: "Bootstrap",
          imageSrc: "devicon--bootstrap.png",
        },
        {
          skillName: "Tailwind CSS",
          imageSrc: "devicon--tailwindcss.png",
        },
        {
          skillName: "Apache Cordova",
          imageSrc: "simple-icons--apachecordova.png",
        },
        {
          skillName: " Vue.js",
          imageSrc: "devicon--vuejs.png",
        },
      ],
    },
    {
      title: "Version Control, Deployment, and DevOps Awareness",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Proficient with Git for source control (branching, merging, pull requests)",
        "⚡ Familiarity with CI/CD pipelines, Docker, Composer, and deployment workflows",
        "⚡ Experience working on multiple cloud platforms",
        "⚡ Ability to manage servers (Apache/Nginx), basic Linux commands, and debugging",
      ],
      softwareSkills: [
        {
          skillName: "GitHub",
          imageSrc: "logos--github-octocat.png",
        },
        {
          skillName: "Jenkins",
          imageSrc: "material-icon-theme--jenkins.png",
        },
        {
          skillName: "Composer",
          imageSrc: "logos--composer.png",
        },
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900",
          },
        },
        {
          skillName: "Azure",
          fontAwesomeClassname: "simple-icons:microsoftazure",
          style: {
            color: "#0089D6",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
        {
          skillName: "ClickUP",
          imageSrc: "simple-icons--clickup.png",
        },
        {
          skillName: "Jira",
          imageSrc: "logos--jira.png",
        },
        {
          skillName: "Trello",
          imageSrc: "devicon--trello.png",
        },
        {
          skillName: "Linux commands",
          imageSrc: "devicon--linux.png",
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "LeetCode",
      iconifyClassname: "simple-icons:leetcode",
      style: {
        color: "#F79F1B",
      },
      profileLink: "https://leetcode.com/layman_brother/",
    },
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/layman_brother",
    },
    {
      siteName: "Codechef",
      iconifyClassname: "simple-icons:codechef",
      style: {
        color: "#5B4638",
      },
      profileLink: "https://www.codechef.com/users/muhammad_1919",
    },
    {
      siteName: "Codeforces",
      iconifyClassname: "simple-icons:codeforces",
      style: {
        color: "#1F8ACB",
      },
      profileLink: "http://codeforces.com/profile/layman_brother",
    },
    {
      siteName: "Hackerearth",
      iconifyClassname: "simple-icons:hackerearth",
      style: {
        color: "#323754",
      },
      profileLink: "https://www.hackerearth.com/@muhammad391",
    },
    {
      siteName: "Kaggle",
      iconifyClassname: "simple-icons:kaggle",
      style: {
        color: "#20BEFF",
      },
      profileLink: "https://www.kaggle.com/laymanbrother",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Indian Institute of Information Technology Kurnool",
      subtitle: "B.Tech. in Computer Engineering",
      logo_path: "iiitk_logo.png",
      alt_name: "IIITDM Kurnool",
      duration: "2016 - 2020",
      descriptions: [
        "⚡ I have studied basic software engineering subjects like DS, Algorithms, DBMS, OS, CA, AI etc.",
        "⚡ Apart from this, I have done courses on Deep Learning, Data Science, Cloud Computing and Full Stack Development.",
        "⚡ I was selected for Merit cum Means Scholarship which is given to top 10% of students in college. I have received award from respected director for consistently best performance in academics.",
      ],
      website_link: "http://iiitk.ac.in",
    },
    {
      title: "Indiana University Bloomington",
      subtitle: "M.S. in Computer Science",
      logo_path: "iu_logo.png",
      alt_name: "Indiana University Bloomington",
      duration: "2021 - 2023",
      descriptions: [
        "⚡ I have taken varity of courses related to Artificial Intelligence which correspond to Explainable AI, Graph Machine Learning, Computer Vision etc.",
        "⚡ Apart from this, I have also done research assistantship. As part of it, I have worked on creating new algorithms in Graph ML and Network Science.",
        "⚡ During my time at university, I was also associated with multimedia department. As part of it, I have worked on some documentry films and interviews.",
      ],
      website_link: "https://www.indiana.edu/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Machine Learning",
      subtitle: "- Andrew Ng",
      logo_path: "stanford_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/22MTSSC5WDTM",
      alt_name: "Stanford University",
      color_code: "#8C151599",
    },
    {
      title: "Deep Learning",
      subtitle: "- Andrew Ng",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/specialization/H8CPSFXAJD2G",
      alt_name: "deeplearning.ai",
      color_code: "#00000099",
    },
    {
      title: "ML on GCP",
      subtitle: "- GCP Training",
      logo_path: "google_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/specialization/EB4VJARK8647",
      alt_name: "Google",
      color_code: "#0C9D5899",
    },
    {
      title: "Data Science",
      subtitle: "- Alex Aklson",
      logo_path: "ibm_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/specialization/PLEAPCSJBZT5",
      alt_name: "IBM",
      color_code: "#1F70C199",
    },
    {
      title: "Big Data",
      subtitle: "- Kim Akers",
      logo_path: "microsoft_logo.png",
      certificate_link:
        "https://drive.google.com/file/d/164zKCFOsI4vGqokc-Qj-e_D00kLDHIrG/view",
      alt_name: "Microsoft",
      color_code: "#D83B0199",
    },
    {
      title: "Advanced Data Science",
      subtitle: "- Romeo Kienzler",
      logo_path: "ibm_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/BH2T9BRU87BH",
      alt_name: "IBM",
      color_code: "#1F70C199",
    },
    {
      title: "Advanced ML on GCP",
      subtitle: "- GCP Training",
      logo_path: "google_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/5JZZM7TNQ2AV",
      alt_name: "Google",
      color_code: "#0C9D5899",
    },
    {
      title: "DL on Tensorflow",
      subtitle: "- Laurence Moroney",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/6T4DCUGNK8J8",
      alt_name: "deeplearning.ai",
      color_code: "#00000099",
    },
    {
      title: "Fullstack Development",
      subtitle: "- Jogesh Muppala",
      logo_path: "coursera_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/certificate/NRANJA66Y2YA",
      alt_name: "Coursera",
      color_code: "#2A73CC",
    },
    {
      title: "Kuberenetes on GCP",
      subtitle: "- Qwiklabs",
      logo_path: "gcp_logo.png",
      certificate_link:
        "https://google.qwiklabs.com/public_profiles/e4d5a92b-faf6-4679-a70b-a9047c0cd750",
      alt_name: "GCP",
      color_code: "#4285F499",
    },
    {
      title: "Cryptography",
      subtitle: "- Saurabh Mukhopadhyay",
      logo_path: "nptel_logo.png",
      certificate_link:
        "https://drive.google.com/open?id=1z5ExD_QJVdU0slLkp8CBqSF3-C3g-ro_",
      alt_name: "NPTEL",
      color_code: "#FFBB0099",
    },
    {
      title: "Cloud Architecture",
      subtitle: "- Qwiklabs",
      logo_path: "gcp_logo.png",
      certificate_link:
        "https://google.qwiklabs.com/public_profiles/5fab4b2d-be6f-408c-8dcb-6d3b58ecb4a2",
      alt_name: "GCP",
      color_code: "#4285F499",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "A seasoned Senior PHP Developer",
  description:
    "I have over 19 years of professional experience in PHP development, building scalable and high-performance web applications using frameworks such as Laravel, Symfony, CodeIgniter, and CakePHP. I specialize in backend architecture, API development, and integration with third-party services, having completed over 100 API integrations across various platforms. My experience includes developing custom WordPress themes and plugins, WooCommerce customizations, and complex CMS-based solutions. I have built RESTful and GraphQL APIs using Symfony API Platform and ensured code quality through unit and integration testing with PHPUnit. I am also experienced in database design and optimization using MySQL, along with Git-based version control and Agile workflows. Additionally, I collaborate closely with frontend teams, converting Figma/PSD designs into responsive applications using modern JavaScript frameworks. Throughout my career, I have delivered 250+ successful projects and maintained long-term client relationships through high-quality, maintainable code.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work Experience",
      work: true,
      experiences: [
        {
          title: "PHP, WordPress, Symfony, Laravel, CodeIgniter, Apache Cordova, API Development",
          company: "Upwork Inc.",
          company_url: "https://www.upwork.com/freelancers/matiq",
          logo_path: "upwork.png",
          duration: "March 2009 - Present",
          location: "Palo Alto, California, USA",
          description:
            "Top-Rated Plus freelancer on Upwork with over 200 completed jobs, 250+ successful projects, and 100% client retention backed by consistent 5-star feedback. Demonstrated expertise in PHP, WordPress, Laravel, and API integrations, with over 6000 hours of logged work and Upwork Skill Certification.",
          color: "#000000",
        },
        {
          title: "Senior Web Developer",
          company: "K6 Media Group",
          company_url: "https://www.k6mediagroup.com/",
          logo_path: "K6.png",
          duration: "July 2016 – 2025",
          location: "Montreal, Quebec, Canada",
          description:
            "Developed custom WordPress themes and plugins, including a Google Web Stories plugin and an SVG animation plugin using the Photopea API. Led technical initiatives to optimize website performance, integrated Python-based tools on Azure, and improved loading speeds by 40%.",
          color: "#0879bf",
        },
        {
          title: "Senior WordPress Developer",
          company: "Easton Consulting Technologies",
          company_url: "https://www.eastontech.net/",
          logo_path: "easton.png",
          duration: "September 2023 – April 2024",
          location: "Miami, Florida, USA",
          description:
            "Transformed Figma designs into fully responsive, high-performance WordPress websites by developing custom themes and plugins. Led a team of junior developers, improved site security and scalability, and integrated third-party APIs to enhance functionality and user engagement.",
          color: "#9b1578",
        },
        {
          title: "PHP Developer",
          company: "Digital Media Ventures",
          company_url: "https://www.digitalmediaventures.com",
          logo_path: "dmv.jpg",
          duration: "January 2006 – March 2009",
          location: "Lahore, Pakistan",
          description:
            "Led the development of scalable web solutions using PHP, CodeIgniter, Joomla, and Magento, enhancing site performance and user experience. Managed a team of developers and delivered CMS and e-commerce projects with 100% client satisfaction and significant improvements in project efficiency.",
          color: "#fc1f20",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "Successfully completed 250+ web development projects, including custom WordPress themes, plugins, and fully responsive websites converted from Figma/PSD designs. Delivered complex WooCommerce solutions, API integrations (100+), and scalable PHP applications using Laravel and CodeIgniter frameworks. Built and customized mobile apps using Apache Cordova, integrated advanced functionalities like SVG animations and speech-to-text syncing. Projects spanned e-commerce, CMS platforms, multimedia applications, and high-traffic websites, consistently meeting performance, security, and client satisfaction benchmarks.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Publications",
  description: "Some of my published Articles, Blogs and Research.",
  avatar_image_path: "projects_image.svg",
};

const publications = {
  data: [
    {
      id: "neuro-symbolic-sudoku-solver",
      name: "Neuro-Symbolic Sudoku Solver",
      createdAt: "2023-07-02T00:00:00Z",
      description: "Paper published in KDD KiML 2023",
      url: "https://arxiv.org/abs/2307.00653",
    },
    {
      id: "mdp-diffusion",
      name: "MDP-Diffusion",
      createdAt: "2023-09-19T00:00:00Z",
      description: "Blog published in Paperspace",
      url: "https://blog.paperspace.com/mdp-diffusion/",
    },
    {
      id: "consistency-models",
      name: "Consistency Models",
      createdAt: "2023-10-12T00:00:00Z",
      description: "Blog published in Paperspace",
      url: "https://blog.paperspace.com/consistency-models/",
    },
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "muhammad_atiq.png",
    description:
      "Feel free to reach out if you're looking to bring your project to life or explore a potential collaboration. I'm open to both freelance and full-time opportunities. With deep expertise in PHP, Laravel, MySQL, and WordPress, I’m ready to deliver high-quality solutions tailored to your needs.",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "I like to document some of my experiences in professional career journey as well as some technical knowledge sharing.",
    link: "https://blogs.muhammadatiq.com/",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle: "189 Korang Road, I-10/3",
    locality: "Islamabad",
    country: "Pakistan",
    region: "Islamabad",
    postalCode: "44000",
    whatsapp: "☎️ +92-333-7668238",
    email: "📧 muhammad.atique@gmail.com",
    mobile: "📞 +92-304-3751567",
    streetAddress: "Kickstart | Campus, 189 Korang Road, I-10/3, Islamabad, Pakistan",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://g.co/kgs/cy9cVN6",
  },
  phoneSection: {
    title: "",
    subtitle: "",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  contactPageData,
};
